import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { SocialLinks } from "../components/SocialLinks";
import { SkinTipsSignup } from "../components/SkinTipsSignup";
import { trackBooked } from "../lib/tracking";
import { ADDRESS_LINE1, ADDRESS_LINE2, PHONE_DISPLAY, PHONE_TEL } from "../data/site";

const NEXT = [
  "A confirmation from Vagaro is on its way to your email and phone.",
  "Please arrive 10 minutes early so we can welcome you and review your goals.",
  "Come with clean skin if you can, and let us know about any new medications or skincare.",
  "Deposits are fully refundable when you cancel or reschedule at least 24 hours ahead. Later cancellations forfeit the deposit.",
];

const Membership = () => (
  <section className="bg-neutral-950 px-6 py-20 text-white md:py-24" data-testid="booked-membership-offer">
    <div className="mx-auto flex max-w-[1000px] flex-col gap-8 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="text-[11px] uppercase tracking-[0.35em] text-neutral-400">Make It a Ritual</p>
        <h2 className="font-display mt-3 text-4xl font-light md:text-5xl">Keep your glow <em>all year.</em></h2>
        <p className="mt-5 max-w-md text-base font-light leading-relaxed text-neutral-300">Memberships start at $199 a month with a monthly facial, an annual RF Microneedling session, member savings and a birthday gift.</p>
      </div>
      <Link to="/memberships" className="btn-ghost-light shrink-0" data-testid="booked-memberships-link">Explore Memberships</Link>
    </div>
  </section>
);

export default function BookingConfirmed() {
  useEffect(() => { trackBooked(); }, []);
  return (
    <main data-testid="booking-confirmed-page">
      <section className="px-6 py-20 md:py-28">
        <div className="mx-auto max-w-[1000px]">
          <p className="kicker rise">Booking Confirmed</p>
          <h1 className="font-display rise d1 mt-4 text-4xl font-light leading-[1.05] text-neutral-950 sm:text-5xl lg:text-6xl" data-testid="booked-title">You're booked. <em>We can't wait to see you.</em></h1>
          <ul className="rise d2 mt-12 space-y-5">
            {NEXT.map((t) => <li key={t} className="flex gap-4 text-base font-light leading-relaxed text-neutral-700"><Check size={18} strokeWidth={1.25} className="mt-1 shrink-0" />{t}</li>)}
          </ul>
          <p className="mt-10 text-sm font-light text-neutral-600" data-testid="booked-contact">
            {ADDRESS_LINE1}, {ADDRESS_LINE2} · Need to change something? <a href={`tel:${PHONE_TEL}`} className="underline">Call</a> or <a href={`sms:${PHONE_TEL}`} className="underline">text</a> {PHONE_DISPLAY}.
          </p>
        </div>
      </section>
      <Membership />
      <section className="bg-[hsl(var(--stone))] px-6 py-20">
        <div className="mx-auto grid max-w-[1000px] gap-12 md:grid-cols-2">
          <div>
            <p className="kicker">Follow Along</p>
            <p className="font-display mt-3 text-3xl font-light text-neutral-950">Results, tips and member offers.</p>
            <SocialLinks className="mt-6" />
          </div>
          <SkinTipsSignup source="booking-confirmed" />
        </div>
      </section>
    </main>
  );
}
